import { __assign, __read, __rest } from "tslib";
import React from "react";
import classNames from "classnames";
import { useDefaultValue } from "../form/controlled";
import { Button } from "../button";
import { Bubble } from "../bubble";
import { useConfig } from "../_util/config-context";
import { SegmentGroup, SegmentGroupItem } from "./SegmentGroup";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { mergeEventProps } from "../_util/merge-event-props";
export var Segment = forwardRefWithStatics(function Segment(props, ref) {
    var _a = useDefaultValue(props, ""), value = _a.value, onChange = _a.onChange, options = _a.options, groups = _a.groups, groupClassName = _a.groupClassName, groupStyle = _a.groupStyle;
    if (groups) {
        return (React.createElement(SegmentGroup, { ref: ref, className: groupClassName, style: groupStyle }, Object.entries(groups).map(function (_a) {
            var _b = __read(_a, 2), key = _b[0], name = _b[1];
            var subOptions = options.filter(function (i) { return i.groupKey === key; });
            return (React.createElement(SegmentGroupItem, { name: name, key: key },
                React.createElement(SegmentMain, __assign({}, props, { options: subOptions, value: value, onChange: onChange }))));
        })));
    }
    return (React.createElement(SegmentMain, __assign({ ref: ref }, props, { value: value, onChange: onChange })));
}, {
    defaultLabelAlign: "middle",
});
Segment.displayName = "Segment";
var SegmentMain = React.forwardRef(function SegmentMain(_a, ref) {
    var _b;
    var value = _a.value, onChange = _a.onChange, options = _a.options, disabled = _a.disabled, rimless = _a.rimless, className = _a.className, style = _a.style, props = __rest(_a, ["value", "onChange", "options", "disabled", "rimless", "className", "style"]);
    var classPrefix = useConfig().classPrefix;
    return (React.createElement("div", __assign({ ref: ref, className: classNames(classPrefix + "-segment", className, (_b = {},
            _b[classPrefix + "-segment--rimless"] = rimless,
            _b)), style: style }, mergeEventProps(props)), options.map(function (option) {
        var button = (React.createElement(Button, { key: option.value, disabled: disabled || option.disabled, tooltip: option.tooltip, htmlType: "button", className: classNames(option.className, {
                "is-selected": option.value === value,
            }), onClick: disabled || option.disabled
                ? null
                : function (event) {
                    onChange(option.value, { event: event });
                }, style: option.style, role: "radio", "aria-checked": option.value === value }, option.text || option.value));
        if (option.bubble) {
            return (React.createElement(Bubble, { key: option.value, content: option.bubble }, button));
        }
        return button;
    })));
});
SegmentMain.displayName = "SegmentMain";
//# sourceMappingURL=Segment.js.map